/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// reactstrap components
import {
  Button,
  Modal,
  ModalBody,
  FormGroup,
  Input
} from "reactstrap";
import Select from "react-select";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { 
  fetchEditModel
} from "../../actions/model_actions";
import { isObjEmpty } from "../../utils/utils";

let options = [
    { value: "white_box", label: "Whitebox" },
    { value: "black_box", label: "Blackbox" }
  ]

class ModelEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        model_id: "",
        model_idState: "",
        model_name: "",
        model_nameState: "",
        userFullName: "",
        userFullNameState: "",
        description: "",
        descriptionState: "",
        modelUrl: "",
        modelUrlState: "",
        model_type: "",
        keyList_route: [], 
        plot_conf: "",
        extra_info: "",
        background_image: "",
        score: "",
        display_specs: "",
        routing_table: {}
    };
  }

  componentDidMount() {
    const { showModelEdit } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { showModelEdit } = this.props;
    if(isObjEmpty(prevProps.showModelEdit) && showModelEdit && showModelEdit.model_id) {
      // console.log("Prevprops: ",prevProps.showModelEdit, "Props: ", showModelEdit);
      this.setState({
        // editModel: !this.state.editModel,
        model_id: showModelEdit.model_id,
        model_name: showModelEdit.model_name,
        description: showModelEdit.description,
        model_type: showModelEdit.model_type,
        extra_info: showModelEdit.extra_info,
        plot_conf: showModelEdit.plot_conf,
        background_image: showModelEdit.background_image
      });
    }
  }

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  // function that verifies if a string has a given length or not
  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  verifyUserId = value => {
    this.setState({userId_isValidated: false})
    var emailRex = /^([a-z]+[0-9]*)+(-[a-z]+[0-9]*)*$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  change = (event, stateName, type, stateNameEqualTo) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "userId":
        if (this.verifyUserId(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger"});
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  toggleModalEdit = () => {
    const { fetchEditModel, userView } = this.props;
    const { model_id, model_name, description, model_type, plot_conf, extra_info, background_image, routing_table, score, display_specs, modelUrl } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let routesObject = {};
    if(score !== "" || (score !== "" && display_specs !== "")) {
      routesObject = Object.assign(routing_table, {[score]: display_specs});
    }
    if(!isObjEmpty(routesObject)) {
      for(let key in routesObject) {
        if(routesObject[key] === "") {
          delete routesObject[key]
        }
      } 
    }
    let userModelsObj = {
      token: idToken,
      client_id: userView._id,
      model_id: model_id,
      model_name: model_name,
      description: description,
      model_type: model_type,
      extra_info: extra_info,
      plot_conf: plot_conf ? plot_conf : "",
      background_image: background_image,
      routing_table: routesObject,
      model_url: modelUrl
    };
    console.log(userModelsObj);
    fetchEditModel(userModelsObj);
    
    this.setState({
      editModel: !this.state.editModel,
      model_id: "",
      model_name: "",
      description: "",
      model_type: "",
      extra_info: "",
      plot_conf: "",
      background_image: "",
      routing_table: {},
      modelUrl: "",
      keyList_route: []
    });
    this.props.handleEditModelModal();
  };

  handleKeysRoute = () => {
    const { keyList_route, score, display_specs, routing_table } = this.state;
    let aux = [...keyList_route, keyList_route.length + 1]
    if(keyList_route.length !== 0) {
      console.log(routing_table, score, display_specs)
      let metricsAux = Object.assign(routing_table, {[score]: display_specs})
      this.setState({keyList_route: aux, score: "", display_specs: "", routing_table: metricsAux})
    } else {
      this.setState({keyList_route: aux})
    }
  }

  setScore = (ev) => {
    this.setState({score: ev.target.value})
  };

  setDisplaySpecs = (ev) => {
    this.setState({display_specs: ev.target.value})
  };

  render() {
    const {
        model_idState, 
        userFullNameState, 
        model_nameState,
        descriptionState,
        modelUrlState,
    } = this.state;
    const { editModel, handleEditModelModal, modelToDelete } = this.props;
    // console.log(modelToDelete)
    
    return (
      <>
        <Modal
          isOpen={editModel}
          toggle={handleEditModelModal}
          size="md"
        >
          <div className="modal-header" style={{justifyContent: 'center'}}>
            <h4 className="title title-up">
              Model Update
            </h4>
          </div>
          <ModalBody>
            <FormGroup className={`has-label ${model_idState}`}>
              <label>Model Id *</label>
              <Input
                name="model_id"
                type="text"
                onChange={e =>
                  this.change(e, "model_id", "userId", 1)
                }
                style={{color: "#000"}}
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].model_id ? modelToDelete[0].model_id : ""}
              />
              {model_idState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${model_nameState}`}>
              <label>Model Name *</label>
              <Input
                name="model_name"
                type="text"
                onChange={e =>
                  this.change(e, "model_name", "length", 1)
                }
                style={{color: "#000"}}
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].model_name ? modelToDelete[0].model_name : ""}
              />
              {model_nameState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${descriptionState}`}>
              <label>Description *</label>
              <Input
                name="description"
                type="text"
                onChange={e =>
                  this.change(e, "description", "length", 1)
                }
                style={{color: "#000"}}
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].description ? modelToDelete[0].description : ""}
              />
              {descriptionState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userFullNameState}`}>
              <label>Model Type *</label>
              <Select
                className="react-select info"
                classNamePrefix="react-select"
                name="singleSelect"
                // defaultInputValue={this.state.showModelEdit && this.state.showModelEdit.model_type ? this.state.showModelEdit.model_type : ""}
                defaultValue={options.filter(option => modelToDelete[0] && option.value === modelToDelete[0].model_type)}
                // defaultValue={this.state.showModelEdit && this.state.showModelEdit.model_type ? this.state.showModelEdit.model_type : ""}
                onChange={value =>
                  this.setState({ model_type: value.value })
                }
                options={options}
                placeholder="Single Select"
              />
            </FormGroup>
            <FormGroup className={`has-label ${userFullNameState}`}>
              <label>Plot Conf</label>
              <Input
                name="plot_conf"
                type="text"
                onChange={e =>
                  this.change(e, "plot_conf", "length", 1)
                }
                style={{color: "#000"}}
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].plot_conf ? modelToDelete[0].plot_conf : ""}
              />
              {userFullNameState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userFullNameState}`}>
              <label>Image</label>
              <Input
                name="background_image"
                type="text"
                onChange={e =>
                  this.change(e, "background_image", "length", 1)
                }
                style={{color: "#000"}}
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].background_image ? modelToDelete[0].background_image : ""}
              />
              {userFullNameState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${modelUrlState}`}>
              <label>Model Url *</label>
              <Input
                name="modelUrl"
                type="text"
                defaultValue={modelToDelete && modelToDelete[0] && modelToDelete[0].model_url ? modelToDelete[0].model_url : ""}
                onChange={e =>
                  this.change(e, "modelUrl", "length", 1)
                }
                style={{color: "#000"}}
                bsSize="md"
              />
              {modelUrlState === "has-danger" ? (
                <label className="error">This field is required.</label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userFullNameState}`}>
              <label>Routing Table </label>
              <Button className="like btn-neutral" color="primary" onClick={this.handleKeysRoute}>
                Add Route
              </Button>
              {this.state.keyList_route && this.state.keyList_route.map((val, index) => {
                return (
                  <div style= {{display: "flex", marginBottom: "3px"}} key={index}>
                    <Input
                      name="key"
                      type="text"
                      onChange={this.setScore}
                      style={{color: "#000", background: "#fff", marginRight: "5px"}}
                      bsSize="sm"
                      placeholder="Key"
                      id={index}
                    />
                    <Input
                      name="value"
                      type="text"
                      onChange={this.setDisplaySpecs}
                      style={{color: "#000", background: "#fff"}}
                      bsSize="sm"
                      placeholder="Value"
                      id={index}
                    />
                  </div>
                )
              })

              }
            </FormGroup>
          </ModalBody>
          <div className="modal-footer justify-content-center">
            <Button
              className="btn-round"
              color="info"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleModalEdit}
              disabled={model_idState === "has-danger" ||
                        model_nameState === "has-danger" || 
                        descriptionState === "has-danger" ||
                        modelUrlState === "has-danger" ? true : false}
            >
              Update Model
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchEditModel }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelEditModal);